export const calculateTimePassedSeconds = (startTime: Date) => {
    const currentTime = new Date();
    const elapsed = currentTime.getTime() - startTime.getTime();

    return Math.floor(elapsed / 1000);
};

export function secondsToTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60); // Convert to minutes
    const remainingSeconds = Math.floor(seconds % 60); // Get remaining seconds

    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
}
